import { ModalActions, ProjectModalTypes, ReferenceModalTypes, SessionsModalTypes } from '../reducers/modals';

export const setModalToDisplay = (modalToDisplay) => ({
    type: ModalActions.SET_MODAL_TO_DISPLAY,
    payload: { modalToDisplay },
});

export const unsetModalToDisplay = () => setModalToDisplay(SessionsModalTypes.SESSIONS_NONE);

export const unsetReferenceModalToDisplay = () => setModalToDisplay(ReferenceModalTypes.ROAD_SECTIONS_NONE);

export const unsetProjectModalToDisplay = () => setModalToDisplay(ProjectModalTypes.PROJECT_SECTIONS_NONE);
